import { mount } from "@vue/test-utils";
import MoneyField from "@/components/core/MoneyField";

describe("MoneyField test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(MoneyField);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component MoneyField", () => {
    expect(wrapper).toBeDefined();
  });
});
